
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isClient() {
      return (
        this.slice.primary.portrait_label[0]?.text.toLowerCase() === 'client'
      )
    },
  },
}
